import { apiClient } from "./api-client"
import type { ProjectSummaryDto } from "@/types/project"
import { demoProjects } from "@/data/demo-data"

const BASE_PATH = "/ReportingInterface"
const isDemoMode = import.meta.env.VITE_DEMO_MODE === "true"

export const projectApi = {
  async getProjectsByTenant(): Promise<ProjectSummaryDto[]> {
    if (isDemoMode) {
      return demoProjects
    }
    return apiClient.get(`${BASE_PATH}/GetProjectsByTenant`)
  },
}
